/* eslint-disable max-lines-per-function */
import React, { useRef, useState } from 'react';
import './tabela-cadastro-edicao-precos.css';
import cidadesEstadosService from '../../services/cidades-estados/cidades-estados-service';
import { ProgressSpinner } from 'primereact/progressspinner';
import DialogSuccessNoReload from '../dialogs/dialog-sucesso-sem-reload';
import DialogErrorNoReload from '../dialogs/dialog-error-sem-reload';
import { decriptObjectOnLocalStorage } from '../../modulos/cripotografia/criptoStorage';
import FormMensalidadeEmLote from './atom/FormMensalidadeEmLote.jsx';
import DataTableMensalidadeLote from './atom/DataTableMensalidadeLote.jsx';
import EdicaoPrecoMensalidadeContext from './context/EdicaoMensalidadeContext';
import { showErrorMessage } from './helper/primereactMessages';
import { retirarMascara } from './helper/formatadores';
import moment from 'moment';
import FormBonificacao from './atom/FormBonificacao.js';

export default function TabelaCadastroEdicaoPrecosMensalidades() {
    const dt = useRef(null);
    const messages = useRef(null);
    const [lotePrecoMensalidadeContextState, setLotePrecoMensalidadeContextState] = useState({
        planosSelecionados: [],
        loadEnvioPlanos: false,
        limparEstadosTabela: false,
        messages
    });
    const [openDialogSuccess, setOpenDialogSuccess] = useState(false);
    const [openDialogError, setOpenDialogError] = useState(false);
    const [dialogMessageErr, setDialogMessageErr] = useState('');
    const [loadingChamadaBackend, setLoadingChamadaBackend] = useState(false);

    const onAgendamento = async (values, resetForm) => {
        try {
            setLoadingChamadaBackend(true);
            setLotePrecoMensalidadeContextState({
                loadEnvioPlanos: true,
                ...lotePrecoMensalidadeContextState
            });

            const { pagamentoBoleto, pagamentoCartao, pagamentoEscelsa } = values;

            const formaPagamento = [];

            if (pagamentoBoleto) {
                formaPagamento.push(1);
            }

            if (pagamentoCartao) {
                formaPagamento.push(7);
            }

            if (pagamentoEscelsa) {
                formaPagamento.push(8);
            }

            const edicaoPlanos = {
                planosCidadesAlteradas: lotePrecoMensalidadeContextState.planosSelecionados.map(plano => ({
                    ...plano,
                    cidade: plano.cidade.id
                })),
                detalhesPlano: {
                    valorBase: retirarMascara(values.valorBase),
                    valorDesconto: retirarMascara(values.valorDesconto),
                    dataInicioDesconto: moment(values.dataInicioDesconto).add(3, 'hours').format('YYYY-MM-DD'),
                    dataFinalDesconto: moment(values.dataFinalDesconto).add(3, 'hours').format('YYYY-MM-DD'),
                    atualizarSomenteValorDesconto: values.atualizarSomenteValorDesconto,
                    atualizarSomenteStatus: values.atualizarSomenteStatus,
                    status: values.status,
                    formaPagamento
                },
                usuario: decriptObjectOnLocalStorage('IDuser'),
                tipo: 'mensalidade',
                dataAgendamento: values.dataAgendamento
            };

            if (edicaoPlanos.detalhesPlano.atualizarSomenteValorDesconto || edicaoPlanos.detalhesPlano.atualizarSomenteStatus) {
                delete edicaoPlanos.detalhesPlano.valorBase;
            }

            if (edicaoPlanos.detalhesPlano.valorDesconto === null || edicaoPlanos.detalhesPlano.valorDesconto === '' || isNaN(edicaoPlanos.detalhesPlano.valorDesconto)) {
                delete edicaoPlanos.detalhesPlano.valorDesconto;
                delete edicaoPlanos.detalhesPlano.dataInicioDesconto;
                delete edicaoPlanos.detalhesPlano.dataFinalDesconto;
            }

            if (edicaoPlanos.detalhesPlano.dataInicioDesconto === 'Invalid date') {
                delete edicaoPlanos.detalhesPlano.dataInicioDesconto;
                delete edicaoPlanos.detalhesPlano.dataFinalDesconto;
            }

            await cidadesEstadosService.postAgendamento(edicaoPlanos);
            setOpenDialogSuccess(true);
            setLoadingChamadaBackend(false);

            setLotePrecoMensalidadeContextState({
                ...lotePrecoMensalidadeContextState,
                limparEstadosTabela: true,
                planosSelecionados: []
            });

            resetForm();
        } catch (err) {
            console.log(err);
            setLoadingChamadaBackend(false);
            showErrorMessage(messages, err.message);
            setOpenDialogError(true);
        }
    };

    const onSubmit = async (values, formikBag) => {
        try {
            setLoadingChamadaBackend(true);

            const { pagamentoBoleto, pagamentoCartao, pagamentoEscelsa } = values;

            const formaPagamento = [];

            if (pagamentoBoleto) {
                formaPagamento.push(1);
            }

            if (pagamentoCartao) {
                formaPagamento.push(7);
            }

            if (pagamentoEscelsa) {
                formaPagamento.push(8);
            }

            const edicaoPlanos = {
                planosCidadesAlteradas: lotePrecoMensalidadeContextState.planosSelecionados.map(plano => ({
                    ...plano,
                    cidade: plano.cidade.id
                })),
                detalhesPlano: {
                    valorBase: retirarMascara(values.valorBase),
                    valorDesconto: retirarMascara(values.valorDesconto),
                    dataInicioDesconto: values.dataInicioDesconto === '' ? null : moment(values.dataInicioDesconto).utc(true).add(3, 'hours'),
                    dataFinalDesconto: values.dataFinalDesconto === '' ? null : moment(values.dataFinalDesconto).utc(true).add(3, 'hours'),
                    atualizarSomenteValorDesconto: values.atualizarSomenteValorDesconto,
                    atualizarSomenteStatus: values.atualizarSomenteStatus,
                    status: values.status,
                    formaPagamento
                },
                usuario: decriptObjectOnLocalStorage('IDuser'),
                tipo: 'mensalidade'
            };

            if (edicaoPlanos.detalhesPlano.atualizarSomenteValorDesconto || edicaoPlanos.detalhesPlano.atualizarSomenteStatus) {
                delete edicaoPlanos.detalhesPlano.valorBase;
            }

            if (edicaoPlanos.detalhesPlano.valorDesconto === null || edicaoPlanos.detalhesPlano.valorDesconto === '' || isNaN(edicaoPlanos.detalhesPlano.valorDesconto)) {
                delete edicaoPlanos.detalhesPlano.valorDesconto;
                delete edicaoPlanos.detalhesPlano.dataInicioDesconto;
                delete edicaoPlanos.detalhesPlano.dataFinalDesconto;
            }

            if (edicaoPlanos.detalhesPlano.dataInicioDesconto === 'Invalid date') {
                delete edicaoPlanos.detalhesPlano.dataInicioDesconto;
                delete edicaoPlanos.detalhesPlano.dataFinalDesconto;
            }

            const response = await cidadesEstadosService.postPlanos(edicaoPlanos, 'mensalidade');

            if (response.planosAtualizados === 0 && response.planosCriados === 0 && !response.mensagem) {
                throw new Error('Plano não cadastrado!');
            }

            if (response.planosAtualizados === 0 && response.planosCriados === 0 && response.mensagem) {
                throw new Error(response.mensagem);
            }

            setLoadingChamadaBackend(false);
            setOpenDialogSuccess(true);
            // setLotePrecoMensalidadeContextState({
            //     ...lotePrecoMensalidadeContextState,
            //     limparEstadosTabela: true,
            //     planosSelecionados: []
            // });
            formikBag.resetForm();
        } catch (err) {
            setLoadingChamadaBackend(false);
            setDialogMessageErr('Houve um problema ao tentar salvar as informações, por favor tente novamente');
            setOpenDialogError(true);
        }
    };

    return <EdicaoPrecoMensalidadeContext.Provider value={{
        lotePrecoMensalidadeContextState,
        setLotePrecoMensalidadeContextState
    }}>
        <DataTableMensalidadeLote 
            loadingChamadaBackend={loadingChamadaBackend} 
            messageRef={messages}
        />
        {
            lotePrecoMensalidadeContextState.planosSelecionados.length > 0 &&
            !loadingChamadaBackend && (
                <>
                    <FormMensalidadeEmLote
                        handleFormAgendamento={onAgendamento}
                        handleFormSubmit={onSubmit}
                    />
                    <br style={{ marginTop: '15pix' }} />
                    <FormBonificacao/>

                </>
            )}
        {loadingChamadaBackend && <ProgressSpinner />}
        <DialogSuccessNoReload
            messageHeader="Planos cadastrados e editados com sucesso!"
            messageBody="Todas as alterações foram salvas!"
            openDialog={openDialogSuccess}
            setOpenDialog={setOpenDialogSuccess}
        />
        <DialogErrorNoReload
            messageHeader="Nenhuma alteração realizada!"
            messageBody={
                dialogMessageErr ?
                    dialogMessageErr :
                    'Houve um problema ao salvar as alterações, tente novamente!'
            }
            openDialog={openDialogError}
            setOpenDialog={setOpenDialogError}
        />

    </EdicaoPrecoMensalidadeContext.Provider>;
}
